import type { BlockMediaPanel } from 'types/block-media-panel';

import React from 'react';

import { Paragraph, Wrap } from '@leafwell/components';

import HeadingBody from './heading-body';
import Figure from './figure';
import WysiwygContent from './wysiwyg-content';

const MediaPanel: React.FC<BlockMediaPanel> = ({
  sectionId,
  instanceId,
  title,
  description,
  label,
  labelIcon,
  image,
  content,
}) => {
  return (
    <Wrap id={sectionId} itemID={`MediaPanel-${instanceId}`}>
      {title || description ? (
        <div className="grid gap-y-6 justify-items-center">
          {title && (
            <HeadingBody
              level="2"
              tagName="h2"
              title={title}
              className="font-semibold text-center"
            />
          )}
          {description && (
            <Paragraph
              dangerouslySetInnerHTML={{ __html: description }}
              size="large"
              className="text-center lg:max-w-5xl"
            />
          )}
        </div>
      ) : null}
      {label ? (
        <div className="mx-auto w-fit flex items-center gap-x-2 justify-center py-3 px-6 bg-green-50 border border-green rounded-lg">
          {labelIcon ? <Figure {...labelIcon} /> : null}
          <Paragraph size="small" className="font-medium text-green-600">
            {label}
          </Paragraph>
        </div>
      ) : null}
      <div className="grid lg:grid-cols-2 border border-lilac-50 rounded-xl lg:w-[900px] xl:w-[1200px] mx-auto">
        {image ? (
          <Figure
            {...image}
            className="rounded-t-xl lg:rounded-l-xl lg:rounded-tr-none"
          />
        ) : null}
        <div className="flex items-center bg-lilac-50 py-3 px-6 lg:py-6 lg:px-10 rounded-b-xl lg:rounded-r-xl lg:last:rounded-bl-none">
          {content ? (
            <WysiwygContent content={content} className="w-full" />
          ) : null}
        </div>
      </div>
    </Wrap>
  );
};

export default MediaPanel;
